
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';
import { loftyGetLoggedUser } from './api/user.api';

// pages
import luis21 from './pages/luis21/luis21'
import inicio from './pages/inicio/inicio'
import terminosycondiciones from './pages/terminosycondiciones/terminosycondiciones'
import khristian1 from './pages/khristian1/khristian1'
import khristian3 from './pages/khristian3/khristian3'
import khristian2 from './pages/khristian2/khristian2'
import luis1 from './pages/luis1/luis1'
import inicionuevo from './pages/inicionuevo/inicionuevo'
import nuevohome from './pages/nuevohome/nuevohome'
import registrousuario from './pages/registrousuario/registrousuario'
import iniciosesion from './pages/iniciosesion/iniciosesion'
import resetearcontrasena from './pages/resetearcontrasena/resetearcontrasena'
import olvidarcontrasena from './pages/olvidarcontrasena/olvidarcontrasena'
import dashboardinicial from './pages/dashboardinicial/dashboardinicial'
import verifiedemail from './pages/verifiedemail/verifiedemail'
import dashboardlistadoproductos from './pages/dashboardlistadoproductos/dashboardlistadoproductos'
import landing1xyi8 from './pages/landing1xyi8/landing1xyi8'
import sobrenosotros24uu4 from './pages/sobrenosotros24uu4/sobrenosotros24uu4'
import paginasobretret4au2r from './pages/paginasobretret4au2r/paginasobretret4au2r'
import error404 from './pages/error404/error404'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const handleData = async () => {
      try {
        const res = await loftyGetLoggedUser({ token: loftytoken });
        addLoftyUserApp(res.user);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        deleteLoftytokenApp();
      }
    }
    handleData();
  }, []);
  if (loading) {
    return <div>Loading ...</div>
  }


  return (
    <Router>
      <Switch>
			<Route exact path="/quienessomos" component={luis21} />
			<Route exact path="/otraversion" component={inicio} />
			<Route exact path="/terminosycondiciones" component={terminosycondiciones} />
			<Route exact path="/gestionactiva1" component={khristian1} />
			<Route exact path="/gestionCFO" component={khristian3} />
			<Route exact path="/gestionactiva2" component={khristian2} />
			<Route exact path="/aprende" component={luis1} />
			<Route exact path="/otraversion2" component={inicionuevo} />
			<Route exact path="/tret2" component={nuevohome} />
			<Route exact path="/signup" component={registrousuario} />
			<Route exact path="/signin" component={iniciosesion} />
			<Route exact path="/resetpassword/:id" component={resetearcontrasena} />
			<Route exact path="/forgotpassword" component={olvidarcontrasena} />
			<Route exact path="/dashboard" component={dashboardinicial} />
			<Route exact path="/verifiedemail" component={verifiedemail} />
			<Route exact path="/dashboard/productos" component={dashboardlistadoproductos} />
			<Route exact path="/" component={landing1xyi8} />
			<Route exact path="/sobrenosotros" component={sobrenosotros24uu4} />
			<Route exact path="/tret" component={paginasobretret4au2r} />
			<Route exact path="*" component={error404} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

